import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/system';
import { useMemo } from 'react';
const Container = styled('span') `
  font-weight: 600;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.grey[400]};
`;
const GamesPlayedSpan = styled('span') `
  color: ${({ theme }) => theme.palette.primary.main};
`;
const Divider = styled('span') `
  font-size: 14;
  color: ${({ theme }) => theme.palette.grey[400]};
`;
const GamesPlayed = ({ gamesPlayed, requiredGames, className }) => {
    const displayGamePlayed = useMemo(() => Math.min(gamesPlayed, requiredGames), [gamesPlayed, requiredGames]);
    return (_jsxs(Container, { className: className, children: [_jsx(GamesPlayedSpan, { "data-testid": "games-played", "data-ignore": true, children: displayGamePlayed }), _jsx(Divider, { "data-ignore": true, children: "\u00A0/\u00A0" }), _jsxs("span", { "data-ignore": true, children: [requiredGames, "\u00A0"] }), _jsx("span", { children: "Games played" })] }));
};
export default GamesPlayed;
